
import { Component, Ref, InjectReactive, Watch, Mixins } from "vue-property-decorator";
import loading from "@/mixins/loading";
import GetMerchantByRemote from "@/mixins/getMerchantByRemote";
import { Form } from "element-ui";
import { cloneDeep, debounce, uniqWith } from "lodash";
import { IHomeInstance } from "@/types/global";
import { getStoreListByMerchant } from "@/api/store";
import { getAllStore } from "@/api/common";

import { getMerchantDetail, saveOrUpdateMerchant, queryStore, getMerchant, getHealthExamineList, getYsbStoreList, getMerchantBuyList } from "@/api/prescriptionDb";

const initFormData = {
    id: "",
    name: "", // 品牌商名称
    stores: [], // 这里先放个 prop 给form 的rule使用
    contact: "", // 负责人
    phone: "",
    status: false,
    autoRegisterUser: false,
    allowUseQrcode: false,
    isShow: true,
    useCustomPres: 31,
    nursePres: 0,
    choiceMerchantId: "",
    remark: "", // 备注
    apiAppKey: "",
    apiAppSecret: "",
    apiStore: "",
    symptomsStatus: 0,
    healthRecordsSwitch: false,
    replaceMallSwitch: false,
    insteadMenu: "",
    insteadAddress: "",
    healthId: "",
    careId: "",
    wsUseBaseStore: 0,
    wsSymptom: 0,
    mixSySymptom: 1,
    enableWeigherV2: 1, // AI评估-体重管理报告类型：0.旧报告 1.新报告（新增品牌方默认为新报告）
    weigherPresLibName: 1, // 新报告处方库：1.舌诊+体脂 2.体质+体脂
    mixYdSymptom: 0, // 0.体质 1.舌诊
    symptomsForPres: 0, // 舌诊报告处方库对应症状选择：0.舌诊 1.体质

    tongueApiQps: undefined,
    withDrawStoreId: "",

    // NOTE: 舌诊拍摄方式控制配置
    medicineBrainTongueShootMode: 1, // 中医大脑舌诊：1.AI智慧屏拍摄（默认） 2.手机拍摄
    wsTongueShootMode: 2, // 望舌知康APP舌诊：1.智慧屏拍摄（默认） 2.手机拍摄
}

@Component({ name: 'prescription-db-edit' })
export default class merchantEdit extends Mixins(loading) {
    @Ref("validateForm") readonly validateFormRef !: Form;
    @Ref("editBox") readonly editBoxRef !: HTMLElement;
    @InjectReactive() HomeInstance !: IHomeInstance;

    merchantId = this.$route.query.merchantId || "";;
    brandName = this.$route.query.brandName || "";
    title = "编辑";
    // NOTE: 锚点导航分组，id 与模板中 form-section 的 id（anchor-xxx）一一对应
    anchorList = [
        { id: "basic", label: "基本信息" },
        { id: "prescription", label: "处方库与产品" },
        { id: "report", label: "报告与基础配置" },
        { id: "switch", label: "其他开关配置" },
        { id: "mall", label: "商城配置" },
        { id: "api", label: "接口对接" },
    ];
    activeAnchor = "basic";
    // NOTE: 锚点平滑滚动期间锁定 scrollspy，避免滚动过程中高亮闪烁
    isAnchorScrolling = false;
    anchorScrollTimer: number | null = null;

    storeInfo = []; // 关联门店数据
    saveLoading = false;
    storeSelectLoading = false;
    allStoreList = [];
    nursePresList = [];
    apiStoreList = [];
    brandAccountStoreList = []; // 品牌分账门店列表

    allMerchantOptions = []; // 把所有的品牌方列表cu存储一份c
    merchantOptions = []; // 品牌方列表
    userLoading = false;

    healthExamineList = [];

    // NOTE: 智养门店 value 根据环境区分，测试环境 63，线上环境 31
    customPresOptions = [
        { label: "智养门店", value: 31 },
        { label: "自定义处方库", value: 1 },
        { label: "引用其他品牌处方库", value: 2 },
        { label: "关闭处方库", value: 3 },
    ];

    merchantStoreSelectLoading = false;
    allMerchantStoreList = [];

    storeShowCount = 20; // 关联门店展示数量

    formData = {
        id: "",
        name: "", // 品牌商名称
        stores: [], // 这里先放个 prop 给form 的rule使用
        contact: "", // 负责人
        phone: "",
        status: false,
        autoRegisterUser: false,
        allowUseQrcode: false,
        isShow: true,
        useCustomPres: 31,
        nursePres: 0,
        choiceMerchantId: "",
        remark: "", // 备注
        apiAppKey: "",
        apiAppSecret: "",
        apiStore: "",
        symptomsStatus: 0,
        healthRecordsSwitch: false,
        replaceMallSwitch: false,
        insteadMenu: "",
        insteadAddress: "",
        bookStatus: false,
        healthId: "",
        careId: "",
        wsUseBaseStore: 0,
        wsBaseStoreId: "",
        wsSymptom: 0,
        mixSySymptom: 1,
        enableWeigherV2: 1, // AI评估-体重管理报告类型：0.旧报告 1.新报告（新增品牌方默认为新报告）
        weigherPresLibName: 1, // 新报告处方库：1.舌诊+体脂 2.体质+体脂
        mixYdSymptom: 0, // 0.体质 1.舌诊
        symptomsForPres: 0,
        usedMerchantList: [],
        tongueApiQps: undefined,
        withDrawStoreId: "",

        // NOTE: 舌诊拍摄方式控制配置
        medicineBrainTongueShootMode: 1, // 中医大脑舌诊：1.AI智慧屏拍摄（默认） 2.手机拍摄
        wsTongueShootMode: 2, // 望舌知康APP舌诊：1.智慧屏拍摄（默认） 2.手机拍摄
    };

    baseFormRules = {
        name: [{ required: true, message: "请输入品牌方名称", trigger: "blur" }],
        useCustomPres: [{ required: true, message: "请选择使用处方库", trigger: "change" }],
        choiceMerchantId: [{ required: true, message: "请选择品牌方", trigger: "change" }],
        nursePres: [{ required: true, message: "请选择调养方案处方库", trigger: "change" }],
        wsSymptom: [{ required: true, message: "请选择小程序舌诊", trigger: "change" }],
        symptomsForPres: [{ required: true, message: "请选择舌诊处方库", trigger: "change" }],
        mixSySymptom: [{ required: true, message: "请选择膳养体测舌诊", trigger: "change" }],
        enableWeigherV2: [{ required: true, message: "请选择AI评估-体重管理报告类型", trigger: "change" }],
        weigherPresLibName: [{ required: true, validator: this.validateWeigherPresLibName, trigger: "change" }],
        mixYdSymptom: [{ required: true, validator: this.validateMixYdSymptom, trigger: "change" }],
        // NOTE: 舌诊拍摄方式必填校验
        medicineBrainTongueShootMode: [{ required: true, message: "请选择中医大脑舌诊拍摄方式", trigger: "change" }],
        wsTongueShootMode: [{ required: true, message: "请选择望舌知康APP舌诊拍摄方式", trigger: "change" }],
    };

    shopRules = {
        insteadMenu: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
        insteadAddress: [{ required: true, message: "请输入菜单跳转地址", trigger: "blur" }]
    }

    tongueRules = {
        wsBaseStoreId: [{ required: true, message: "请选择产品基准门店", trigger: "change" }]
    }

    get formRules() {
        return {
            ...this.baseFormRules,
            ...(this.formData.replaceMallSwitch ? this.shopRules : {}),
            ...(this.formData.wsUseBaseStore ? this.tongueRules : {})
        }
    }

    replaceMallSwitchChange($event) {
        if (!$event) {
            this.formData.insteadMenu = "";
            this.formData.insteadAddress = "";
        }
    }

    // AI评估-体重管理报告类型切换
    handleYdReportTypeChange(val: number) {
        // 切换报告类型时，重置处方库选择
        if (val === 1) {
            this.formData.weigherPresLibName = 1;
        }
        this.formData.mixYdSymptom = 0;
        // 清除验证状态
        this.validateFormRef.clearValidate(['weigherPresLibName', 'mixYdSymptom']);
    }

    // 验证新报告处方库
    validateWeigherPresLibName(rule: any, value: any, callback: Function) {
        if (this.formData.enableWeigherV2 === 1 && !value) {
            callback(new Error("请选择AI评估-体重管理处方库"));
        } else {
            callback();
        }
    }

    // 验证旧报告舌诊
    validateMixYdSymptom(rule: any, value: any, callback: Function) {
        if (this.formData.enableWeigherV2 === 0 && (value === undefined || value === null)) {
            callback(new Error("请选择AI评估-体重管理舌诊"));
        } else {
            callback();
        }
    }

    validateStoreInfo(rule, value, callback) {
        if (this.storeInfo?.length) return callback();
        return callback(new Error("请选择关联门店"))
    };

    mounted() {
        this.getMerchantList("");
        this.getHealthExamineList("");
        // 先加载门店列表，再加载详情（详情需要门店列表做ID→名称映射）
        getStoreListByMerchant({ merchantId: this.merchantId }).then((res) => {
            this.allMerchantStoreList = res.data;
            this.getMerchantDetail();
        });
        // 页面加载时预加载品牌分账门店列表，由前端 select 自行过滤
        this.getBrandAccountStoreListRemote("");
        this.getNursePresList("");
        this.getApiStoreList("");
    }

    beforeDestroy() {
        if (this.anchorScrollTimer) {
            clearTimeout(this.anchorScrollTimer);
            this.anchorScrollTimer = null;
        }
    }

    // 点击锚点，平滑滚动到对应分组
    scrollToAnchor(id: string) {
        const box = this.editBoxRef;
        const el = box?.querySelector(`#anchor-${id}`) as HTMLElement | null;
        if (!box || !el) return;
        this.activeAnchor = id;
        // NOTE: 内容不足一屏时无可滚动，直接高亮点击项，避免滚动结束后 scrollspy 重新计算把高亮切回顶部
        if (box.scrollHeight <= box.clientHeight) {
            return;
        }
        // NOTE: 平滑滚动过程中锁定 scrollspy，避免滚动事件把高亮切回旧分组造成闪烁
        this.isAnchorScrolling = true;
        const boxRect = box.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        const target = box.scrollTop + (rect.top - boxRect.top) - 80;
        box.scrollTo({ top: target, behavior: "smooth" });
        this.resetAnchorScrollTimer();
    }

    // 滚动时根据各分组位置高亮当前锚点
    onScroll() {
        // 程序化跳转滚动期间，滚动事件仍会触发，先忽略 scrollspy，等滚动停止后再同步
        if (this.isAnchorScrolling) {
            this.resetAnchorScrollTimer();
            return;
        }
        this.updateActiveAnchor();
    }

    // 根据滚动位置计算并高亮当前分组
    updateActiveAnchor() {
        const box = this.editBoxRef;
        if (!box) return;
        const boxRect = box.getBoundingClientRect();
        const threshold = 80;
        let current = this.anchorList[0].id;
        for (const item of this.anchorList) {
            const el = box.querySelector(`#anchor-${item.id}`) as HTMLElement | null;
            if (!el) continue;
            if (el.getBoundingClientRect().top <= boxRect.top + threshold) {
                current = item.id;
            }
        }
        this.activeAnchor = current;
    }

    // 重置锚点滚动结束检测：滚动停止 150ms 后解锁 scrollspy 并同步一次
    resetAnchorScrollTimer() {
        if (this.anchorScrollTimer) clearTimeout(this.anchorScrollTimer);
        this.anchorScrollTimer = window.setTimeout(() => {
            this.isAnchorScrolling = false;
            this.anchorScrollTimer = null;
            this.updateActiveAnchor();
        }, 150);
    }

    // 校验不通过时滚动到第一个错误项，避免必填提示在可视区域外
    scrollToFormError() {
        this.$nextTick(() => {
            const box = this.editBoxRef;
            const el = box?.querySelector(".el-form-item.is-error") as HTMLElement | null;
            if (!box || !el) return;
            const boxRect = box.getBoundingClientRect();
            const rect = el.getBoundingClientRect();
            // 已完整处于可视区域时不滚动，避免无谓跳动
            if (rect.top >= boxRect.top && rect.bottom <= boxRect.bottom) return;
            this.isAnchorScrolling = true;
            const target = box.scrollTop + (rect.top - boxRect.top) - 80;
            box.scrollTo({ top: Math.max(target, 0), behavior: "smooth" });
            this.resetAnchorScrollTimer();
        });
    }

    getHealthExamineList(str) {
        if (typeof str == "object") {
            str = "";
        }
        getHealthExamineList({ examName: str }).then((res) => {
            this.healthExamineList = res.data;
        });
    }

    getMerchantListRemote = debounce(function(merchantName) {
        this.userLoading = true;
        getMerchant({ merchantId: this.merchantId, name: merchantName }).then((res) => {
            this.userLoading = false;
            this.merchantOptions = res.data;
            if (merchantName == "") {
                this.allMerchantOptions = res.data;
            }
        }).catch((err) => { this.userLoading = false; });
    })

    getMerchantList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantListRemote(str)
    }

    getNursePresListRemote = debounce(function (str) {
        this.userLoading = true;
        getMerchant({ name: str }).then((res) => {
          this.userLoading = false;
          this.merchantOptions = res.data;
          this.nursePresList = [ { id: 0, name: "调养处方管理"  }, ...res.data ];
        }).catch((err) => { this.userLoading = false; });
    })

    getNursePresList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getNursePresListRemote(str);
    }

    getMerchantStoreRemote = debounce(function (str) {
        this.merchantStoreSelectLoading = true;
        getStoreListByMerchant({merchantId: this.merchantId, name: str}).then((res) => {
          this.merchantStoreSelectLoading = false;
          this.allMerchantStoreList = res.data;
        }).catch((err) => {}).finally(() => {
            this.merchantStoreSelectLoading = false;
        });
    })

    getMerchantStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantStoreRemote(str)
    }

    getApiStoreListRemote = debounce(function (str) {
        getAllStore({ storeName: str }).then((res) => {
          this.apiStoreList = res.data;
        }).catch((err) => {}).finally(() => {
        });
    })

    getApiStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getApiStoreListRemote(str)
    }

    // 品牌分账门店列表
    getBrandAccountStoreListRemote = debounce(function (str) {
        getMerchantBuyList({ merchantId: this.merchantId || 0 }).then((res) => {
          this.brandAccountStoreList = res.data;
        }).catch((err) => {}).finally(() => {
        });
    })

    getBrandAccountStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getBrandAccountStoreListRemote(str)
    }

    getMerchantDetail() {
        if (!this.merchantId) {
            this.title = "新增";
            return;
        }
        getMerchantDetail(this.merchantId).then((res) => {
            const { stores, status, autoRegisterUser, allowUseQrcode, isShow, healthRecordsSwitch, replaceMallSwitch, bookStatus, wsBaseStoreId, usedMerchantList, tongueApiQps, withDrawStoreId } = res.data;

            Object.assign(this.formData, { ...res.data, status: Boolean(status), autoRegisterUser: Boolean(autoRegisterUser), allowUseQrcode: Boolean(allowUseQrcode), isShow: Boolean(isShow),
                healthRecordsSwitch: Boolean(healthRecordsSwitch), replaceMallSwitch: Boolean(replaceMallSwitch), bookStatus: Boolean(bookStatus), wsBaseStoreId: wsBaseStoreId || "",
                usedMerchantList: usedMerchantList?.map((el:any) => el.id) || [], tongueApiQps: tongueApiQps ?? undefined,
                enableWeigherV2: res.data.enableWeigherV2 ?? 1,
                weigherPresLibName: res.data.weigherPresLibName ?? 1,
                mixYdSymptom: res.data.mixYdSymptom ?? 0,
                // NOTE: 舌诊拍摄方式控制配置，默认值处理
                medicineBrainTongueShootMode: res.data.medicineBrainTongueShootMode ?? 1, // 默认AI智慧屏拍摄
                wsTongueShootMode: res.data.wsTongueShootMode ?? 2, // 默认智慧屏拍摄
            });

            this.storeInfo = cloneDeep(stores)?.map((row) => ({ id: row.storeId, storeName: row.storeName }));
            // 如果有分账门店ID，先加载门店列表用于回显
            if (withDrawStoreId) {
                this.getBrandAccountStoreListRemote("");
            }
        })
    }

    getStoreRemote = debounce(function (str) {
        this.storeSelectLoading = true;
        queryStore({ storeId: str, storeName: str, pageNum: 1, pageSize: 500 }).then((res) => {
            this.storeSelectLoading = false;
            this.allStoreList = res.data;
        }).catch((err) => { });
    })

    getStoreList(str) {
        if (typeof str == "object") {
            str = "";
        }
        getYsbStoreList({
            keyWord: str,
            pageNum: 1,
            pageSize: 1000,
        })
        .then((res) => {
            this.allStoreList = res.data.list;
        })
        .catch((err) => {});
    }

    setCurUser(cur, key) {
        this[key].push({ ...cur, userId: cur.id });
        const comparator = (obj1, obj2) => obj1.id === obj2.id;
        this[key] = uniqWith(this[key], comparator)
    }

    handleClose(cur, key) {
        this[key] = this[key].filter((item) => {
            return item.id != cur.id;
        });
    }

    dialogClose() {
        this.storeInfo = []; // 关联门店数据
        this.storeShowCount = 20;
        this.formData = cloneDeep(initFormData);
        this.validateFormRef.resetFields();
        this.HomeInstance.tabRemove("merchantEdit");
    }

    dialogConfirm() {
        // 判断百症调养是否为使用品牌方内容
        if (this.formData.symptomsStatus == 1) {
            this.$confirm(`使用品牌方内容将不展示养身帮的内容，请尽快在品牌方的【百症调养配置】内进行对应内容配置。`, "提示", {
                showCancelButton: false,
                confirmButtonText: "我已知晓",
                type: "warning",
            }).then(() => {
                this.confirmCall();
            });
            return;
        }
        this.confirmCall();

    }

    getUsedMerchantList() {
        const totalMap = _.keyBy(this.allMerchantOptions, 'id');
        const result = this.formData.usedMerchantList.map(id => totalMap[id]).filter(Boolean)
        return result;
    }

    confirmCall() {
        this.validateFormRef.validate().then(() => {
            console.log(this.formData)
            const params = {
                ...this.formData,
                stores: cloneDeep(this.storeInfo)?.map((row) => ({ storeId: row.id, storeName: row.storeName })),
                status: Number(this.formData.status),
                autoRegisterUser: Number(this.formData.autoRegisterUser),
                allowUseQrcode: Number(this.formData.allowUseQrcode),
                isShow: Number(this.formData.isShow),
                choiceMerchantId: this.formData.useCustomPres == 2 ? this.formData.choiceMerchantId : "",
                healthRecordsSwitch: Number(this.formData.healthRecordsSwitch),
                replaceMallSwitch: Number(this.formData.replaceMallSwitch),
                insteadMenu: this.formData.replaceMallSwitch ? this.formData.insteadMenu : "",
                insteadAddress: this.formData.replaceMallSwitch ? this.formData.insteadAddress : "",
                bookStatus: Number(this.formData.bookStatus),
                wsUseBaseStore: Number(this.formData.wsUseBaseStore),
                wsSymptom: Number(this.formData.wsSymptom),
                mixSySymptom: Number(this.formData.mixSySymptom),
                enableWeigherV2: Number(this.formData.enableWeigherV2),
                weigherPresLibName: this.formData.enableWeigherV2 === 1 ? Number(this.formData.weigherPresLibName) : "",
                mixYdSymptom: this.formData.enableWeigherV2 === 0 ? Number(this.formData.mixYdSymptom) : "",
                symptomsForPres: Number(this.formData.symptomsForPres),
                usedMerchantList: this.getUsedMerchantList(),

                tongueApiQps: this.formData.tongueApiQps ?? null,

                // NOTE: 舌诊拍摄方式控制配置
                medicineBrainTongueShootMode: Number(this.formData.medicineBrainTongueShootMode),
                wsTongueShootMode: Number(this.formData.wsTongueShootMode),
            }
            console.log(params)
            this.saveLoading = true;
            saveOrUpdateMerchant(params).then(() => {
                this.dialogClose();
                this.$message.success("保存成功");
            }).finally(() => {
                this.saveLoading = false;
            })
        }, () => {
            this.scrollToFormError();
        });
    }

    @Watch('storeInfo')
    validateField(val, oldVal) {
        this.validateFormRef.validateField(["storeInfo"])
    }
}
